import { useTranslation } from "react-i18next";
import TabsNavigationBar from "../../components/bar/TabsNavigationBar/TabsNavigationBar";

function TransferNavigationBar(props) {
    const { t } = useTranslation();
    return (
        <TabsNavigationBar
            multipleLocationKey={props.multipleLocationKey}
            pages={[
                {
                    label: t("headers.transfer_investment_bills"),
                    link: "/financial-panel/transfer/investment_bills/",
                },
                {
                    label: t("headers.transfer_individual_bills"),
                    link: "/financial-panel/transfer/individual_bills/",
                },
                {
                    label: t("headers.transfer_individual_bills_withdrawal"),
                    link: "/financial-panel/transfer/individual_bills/withdrawal/",
                },
            ]}
        />
    );
}

export default TransferNavigationBar;
